import { Box, Typography } from '@mui/material';
import { useStylesProductPageUXB } from '../SharedStyles/SharedStyles';
import { useEffect, useState } from 'react';
import { getEventProductLinked } from 'api/services/EventsService';
import {
  WHITELABEL_IMAGE_PLACEHOLDER,
  WHITELABEL_EVENT_KEY
} from 'components/constants/Constants';
import { EventProduct, ProductType } from 'types/Products';
import { LinkedProductPreviewCard } from './LinkedProductPreviewCard';
import { getProductPermalink } from 'helpers/getProductPermalink';
import MyCarousel from 'components/common/Carousel/Carousel';

type RelatedProductsProps = {
  companyKey: string;
  productKey: string;
  productType: ProductType.FORMULATIONS | ProductType.INGREDIENTS;
};

const RelatedProducts: React.FC<RelatedProductsProps> = props => {
  const { classes } = useStylesProductPageUXB();
  const linkedProductType =
    props.productType === ProductType.INGREDIENTS
      ? ProductType.FORMULATIONS
      : ProductType.INGREDIENTS;
  const linkedProductTypeLabel =
    linkedProductType === ProductType.FORMULATIONS
      ? 'concepts'
      : linkedProductType.toLowerCase();

  useEffect(() => {
    getEventProductLinked(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      WHITELABEL_EVENT_KEY!,
      props.companyKey,
      props.productKey,
      linkedProductType,
      ({ data }) => {
        setProducts(data);
      },
      () => {}
    );
  }, [
    linkedProductType,
    props.companyKey,
    props.productKey,
    props.productType
  ]);

  const [products, setProducts] = useState<EventProduct[]>();

  return products?.length ? (
    <Box className={classes.productInformationGrid}>
      <Typography
        variant="h3"
        sx={{
          color: 'GrayText'
        }}
      >
        Our related marketing {linkedProductTypeLabel}(s)
      </Typography>
      <Box sx={{ position: 'relative', height: '320px' }}>
        <Box
          sx={{
            width: '96%',
            margin: '0 2%',
            position: 'absolute',
            height: '100%'
          }}
        >
          <MyCarousel responsive={responsive} blackArrows>
            {products?.map(p => {
              const imgReference = p.images?.[0]?.reference;
              const imageUrl = imgReference
                ? `${process.env.REACT_APP_COVALO_STATIC_CONTENT}/events/${WHITELABEL_EVENT_KEY}/${imgReference}`
                : WHITELABEL_IMAGE_PLACEHOLDER;
              return (
                <LinkedProductPreviewCard
                  key={p.name}
                  productName={p.name}
                  linkedProductTypeLabel={linkedProductTypeLabel
                    .replace(/.$/, '')
                    .toLowerCase()}
                  imageUrl={imageUrl}
                  link={getProductPermalink(
                    props.productType === ProductType.FORMULATIONS
                      ? ProductType.INGREDIENTS
                      : ProductType.FORMULATIONS,
                    p.old_key ?? ''
                  )}
                />
              );
            })}
          </MyCarousel>
        </Box>
      </Box>
    </Box>
  ) : null;
};

export default RelatedProducts;

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 2
  },
  desktop: {
    breakpoint: { max: 3000, min: 1100 },
    items: 3

    // partialVisibilityGutter: -40
  },
  tablet: {
    breakpoint: { max: 1100, min: 880 },
    items: 2
    // partialVisibilityGutter: -40
  },
  mobile: {
    breakpoint: { max: 850, min: 0 },
    items: 2
  },
  mini: {
    breakpoint: { max: 580, min: 0 },
    items: 1
  }
};
